import { createReducer, INITIAL_STATE } from '../../../shared/redux';
import { confirmInviteAPIConfig } from '../../../shared/api-configs/invite';

export const CONFIRM_INVITE_REQUEST_CALLED = '@auth/CONFIRM_INVITE_REQUEST_CALLED';
export const CONFIRM_INVITE_REQUEST_SUCCEEDED = '@auth/CONFIRM_INVITE_REQUEST_SUCCEEDED';
export const CONFIRM_INVITE_REQUEST_FAILED = '@auth/CONFIRM_INVITE_REQUEST_FAILED';
export const CONFIRM_INVITE_NOT_LOGGED_USER_EXCEPTION_RAISED = '@auth/CONFIRM_INVITE_NOT_LOGGED_USER_EXCEPTION_RAISED';

export const isSignInFromInvite = state => state.auth.confirmInvite.fromInvite;

export const requestConfirmInvite = ({
    newUser,
    fullName,
    phone,
} = {}) => ({
    type: CONFIRM_INVITE_REQUEST_CALLED,
    actionTypes: {
        success: CONFIRM_INVITE_REQUEST_SUCCEEDED,
        fail: CONFIRM_INVITE_REQUEST_FAILED,
    },
    config: confirmInviteAPIConfig({ newUser, fullName, phone }),
});

export const raiseConfirmInviteNotLoggedUserException = ({ error }) => ({
    type: CONFIRM_INVITE_NOT_LOGGED_USER_EXCEPTION_RAISED,
    payload: { error },
});

const updateError = (state = {}, action) => ({
    ...state, error: action.payload.error, loading: false,
});

export const confirmInviteReducer = createReducer({
    [INITIAL_STATE]: {
        loading: false,
    },

    [CONFIRM_INVITE_REQUEST_CALLED]: state => ({ ...state, loading: true }),
    [CONFIRM_INVITE_REQUEST_SUCCEEDED]: state => ({ ...state, loading: false }),
    [CONFIRM_INVITE_REQUEST_FAILED]: state => ({ ...state, loading: false }),
    [CONFIRM_INVITE_NOT_LOGGED_USER_EXCEPTION_RAISED]: updateError,
});
